import PropTypes from 'prop-types';

import Button from 'shopper/components/Button';
import Flex from 'shopper/components/Flex';
import Icon from 'shopper/components/Icon';

import useWishlist from 'hooks/useWishlist';

import { stripDuplicates } from 'lib/array';

const toKeywordsWithLimit = (keywords, maxKeywords) =>
  maxKeywords && keywords.length > maxKeywords
    ? keywords.slice(0, maxKeywords)
    : keywords;

const WishlistSuggestionsKeywords = ({
  gaEventCategory,
  keywordsDisplay,
  keywordButtonType,
  keywordButtonTypeCanChange,
  maxKeywords,
  ...rest
}) => {
  const { addOfferWishlistKeyword, removeOfferWishlistKeyword, offerWishlist } =
    useWishlist(gaEventCategory, {
      gaEventLabel: 'wishlist_suggestions',
    });

  const isKeywordAdded = (keywordDisplay) =>
    offerWishlist?.items.some((item) => item.keywordDisplay === keywordDisplay);

  const onKeywordButtonClick = (keywordDisplay) => {
    if (isKeywordAdded(keywordDisplay)) {
      removeOfferWishlistKeyword({ keywordDisplay });
      return;
    }

    addOfferWishlistKeyword({ keywordDisplay });
  };
  return (
    <Flex flexWrap="wrap" maxWidth="100%" {...rest}>
      {toKeywordsWithLimit(stripDuplicates(keywordsDisplay), maxKeywords).map(
        (keywordDisplay) => {
          const keywordAlreadyAdded = isKeywordAdded(keywordDisplay);

          return (
            <Button
              key={keywordDisplay}
              size="size3"
              data-test-selector="add-keyword-to-wishlist"
              mb={2}
              mr={2}
              type={
                keywordButtonType ||
                (keywordButtonTypeCanChange && keywordAlreadyAdded
                  ? 'primary'
                  : 'subtle')
              }
              iconLeft={
                keywordAlreadyAdded ? (
                  <Icon name="heart-filled" />
                ) : (
                  <Icon name="heart" />
                )
              }
              onClick={() => onKeywordButtonClick(keywordDisplay)}
            >
              {keywordDisplay}
            </Button>
          );
        }
      )}
    </Flex>
  );
};

WishlistSuggestionsKeywords.defaultProps = {
  keywordsDisplay: [],
  keywordButtonType: null,
  keywordButtonTypeCanChange: false,
  maxKeywords: null,
};

WishlistSuggestionsKeywords.propTypes = {
  keywordsDisplay: PropTypes.arrayOf(PropTypes.string),
  gaEventCategory: PropTypes.string.isRequired,
  keywordButtonType: PropTypes.string,
  keywordButtonTypeCanChange: PropTypes.bool,
  maxKeywords: PropTypes.number,
};

export default WishlistSuggestionsKeywords;
